const dropdowns = require('./dropdowns');
const pagination = require('./pagination');
const clearAllHandler = require('./clear-all-handler');
const tagHandler = require('./tag-handler');
const tableOfContents = require('./table-of-contents');
const showMore = require('./showMore');
const toggleModuleVisibility = require('./toggle-module-visibility');

module.exports = function () {
    var $page = $('#landing-page-with-search');
    
    window.pageInitialized = window.pageInitialized || false;
    
    if (!$page.length) {
      return;
    }
    
    var apiEndpoint = $page.data('searchEndpoint');
    
    if (!window.pageInitialized) {
        dropdowns(apiEndpoint);
        clearAllHandler(apiEndpoint);
    }

    pagination(apiEndpoint);
    tagHandler(apiEndpoint);
    tableOfContents(apiEndpoint);
    showMore(apiEndpoint);
    toggleModuleVisibility();

    window.pageInitialized = true;
};